var tabPanelHidden = 'qsytre0';

export { tabPanelHidden };
//# sourceMappingURL=tabs-primitive.css.js.map
